import {Tooltip} from 'platform/components';

import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function RealMileageInput() {
  return (
    <Tooltip
      label={i18n.t('entity.vehicle.labels.realMileage')}
      description={i18n.t('entity.vehicle.descriptions.realMileage')}
      placement="top-start"
    >
      <Field
        type="number"
        name="realMileage"
        label={i18n.t('entity.vehicle.labels.realMileage')}
        suffix={i18n.t('general.metric.km')}
      />
    </Tooltip>
  );
}
